'use client';

import { ArrowLeft } from 'lucide-react';
import clsx from 'clsx';
import { BackButtonSkeleton } from './BackButtonSkeleton';

export function BackButton({
  defaultHref,
  className,
  children,
}: {
  defaultHref?: string;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <BackButtonSkeleton
      className={clsx('link mb-4 flex w-fit items-center gap-2 text-xs', className)}
      defaultHref={defaultHref}
    >
      <ArrowLeft size={12} />
      {children}
    </BackButtonSkeleton>
  );
}
